import {Navigate, NonIndexRouteObject} from "react-router"
import {
    cmsConfigurationStore,
    cmsDetailStore,
    cmsListStore,
    cmsRuleCreateStore,
    cmsRuleDetailStore,
    cmsRulesListStore,
    cmsShippingOptionStore,
    cmsStorageStore,
    navigationStore,
    validationStore
} from "../store";
import React from "react";
import {ErrorPage} from "../components/page";
import {CmsApp} from "../components/app/CmsApp";


const cms:NonIndexRouteObject[] = [
    {
        path: `/cms`,
        element: <CmsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams
            cmsListStore.page = parseInt(searchParams.get("page") || "") || 1
            cmsListStore.size = parseInt(searchParams.get("size") || "") || 25

            cmsListStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/cms/create`,
        element: <CmsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/cms/:id`,
        element: <CmsApp mode={'detail'}/>,
        errorElement: <Navigate to={`/cms`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            cmsDetailStore.id = params.id!!
            const result = await cmsDetailStore.load()
            if (!result) {
                throw Error
            }

            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/cms/:customerId/configuration`,
        element: <CmsApp mode={'detail'} tab={'configuration'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({params, request}) => {
            cmsStorageStore.init() // init only - refresh via socket
            cmsDetailStore.id = params.customerId!!
            cmsDetailStore.load().finally()

            cmsConfigurationStore.customerId = params.customerId!!
            await Promise.all([
                await cmsShippingOptionStore.load(),
                await cmsConfigurationStore.load()
            ])


            navigationStore.setActivePath(request)

            return null
        }
    },
    {
        path: `/cms/:customerId/scan-document-rule`,
        element: <CmsApp mode={'detail'} tab={'scan-document-rules'}/>,
        errorElement: <Navigate to={`/cms`} replace={true}/>,
        loader: async ({params, request}) => {
            cmsDetailStore.id = params.customerId!!
            cmsDetailStore.load().finally()

            cmsRulesListStore.customerId = params.customerId!!
            const searchParams = new URL(request.url).searchParams
            cmsRulesListStore.page = parseInt(searchParams.get("page") || "") || 1
            cmsRulesListStore.size = parseInt(searchParams.get("size") || "") || 25

            cmsRulesListStore.load().finally()
            navigationStore.setActivePath(request)

            return null
        }
    },
    {
        path: `/cms/:customerId/scan-document-rule/create`,
        element: <CmsApp mode={'detail'} tab={'scan-document-rule-create'}/>,
        errorElement: <Navigate to={`/cms`} replace={true}/>,
        loader: async ({params, request}) => {
            cmsDetailStore.id = params.customerId!!
            cmsDetailStore.load().finally()

            cmsRuleCreateStore.customerId = params.customerId!!
            validationStore.reset()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/cms/:customerId/scan-document-rule/:id`,
        element: <CmsApp mode={'detail'} tab={'scan-document-rule-detail'}/>,
        errorElement: <Navigate to={`/cms`} replace={true}/>,
        loader: async ({params, request}) => {
            cmsDetailStore.id = params.customerId!!
            cmsDetailStore.load().finally()

            validationStore.reset()
            cmsRuleDetailStore.id = params.id!!
            cmsRuleDetailStore.customerId = params.customerId!!
            const result = await cmsRuleDetailStore.load()
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    cms
}
